<template>
  <v-flex xs12 px-3 style="padding-top: 10px !important;" class="main">
    <v-flex xs12 style="overflow-y: hidden;">
      <v-btn @click="gotoFrontPage" style="width: 50px;" class="breadCrumb">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn @click="startLabelling" class="breadCrumb">
        Labelling
      </v-btn>
      <v-btn @click="selectSupplier(currentSupplier)" v-if="currentSupplier" class="breadCrumb">
        {{ currentSupplier.name }}
      </v-btn>
      <v-btn @click="selectField(currentField)" v-if="currentField" class="breadCrumb">
        {{ currentField.address.name && currentField.address.name !== '' ? currentField.address.name : currentField.address.text }}
      </v-btn>
      <div :key="'button1_' + updateCounter" style="display: inline; float: right;">
        <v-btn @click="addCategory()" class="addCategory" v-if="isInLabelling">Add category</v-btn>
        <v-btn @click="openPrintDialog" class="print" v-if="!isInLabelling && showSupplierList">Print</v-btn>
      </div>
      <div style="height: 5px;"></div>
    </v-flex>
    <v-flex xs12 style="overflow-y: hidden; padding-top: 0 !important; padding-bottom: 12px !important;" v-if="isInLabelling">
      <div :key="'button2_' + updateCounter" style="display: inline; float: left;">
        <div style="display: inline-block; margin-right: 10px !important;">
          <v-menu v-model="currentDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width>
            <template v-slot:activator="{ on }">
              <v-btn flat class="changeDate" v-on="on"><v-icon>event</v-icon>&nbsp;&nbsp;<div style="width: 100px;">{{ toDateDanish(currentDate) }}</div></v-btn>
            </template>
            <v-date-picker v-model="currentDate" @input="currentDateMenu = false" @change="dateChanged" :min="todayMinus30Days" :max="today"></v-date-picker>
          </v-menu>
        </div>
      </div>
      <div :key="'button3_' + updateCounter" style="display: inline; float: right;">
        <v-btn @click="confirmEndDay()" class="endDay" style="margin-right: 10px !important;" :disabled="!canEndDay" v-if="isInLabelling">End day</v-btn>
        <v-btn @click="confirmCompleteTasks()" class="completed" :disabled="!canComplete" style="" v-if="isInLabelling">Completed</v-btn>
      </div>
    </v-flex>
    <v-container fluid py-2 px-3 v-show="showSupplierList" class="supplierButtons">
      <v-layout style="max-height: calc(100vh - 190px);">
        <v-flex xs12 style="overflow-y: auto;">
          <v-flex xs12 v-for="(supplier, i) in suppliers" :key="i" :style="'height: ' + Math.min(20, Math.max(6, 65 / suppliers.length)) + 'vh; margin-bottom: ' + (Math.max(0.5, 8 / suppliers.length)) + 'vh !important;'" class="supplierButton">
            <v-btn @click="selectSupplier(supplier)" :style="'width: 100%; height: ' + Math.min(20, Math.max(6, 65 / suppliers.length)) + 'vh !important; max-height: 30vh !important; font-size: ' + Math.min(Math.max(50 - (5 * suppliers.length), 14), 25) + 'pt !important;'">{{ supplier.name }}</v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-show="showFieldList" class="fieldButtons">
      <v-layout style="max-height: calc(100vh - 190px);">
        <v-flex xs12 style="overflow-y: auto;">
          <div v-for="(field, i) in fields" :key="i" :style="'width: 100%; height: ' + Math.min(20, Math.max(6, 65 / fields.length)) + 'vh; margin-bottom: ' + (Math.max(0.5, 8 / fields.length)) + 'vh !important;'">
            <v-btn @click="selectField(field)" :style="'width: 100%; height: ' + Math.min(20, Math.max(6, 65 / fields.length)) + 'vh !important; max-height: 30vh !important; font-size: ' + Math.min(Math.max(50 - ( 5 * fields.length), 8), 13) + 'pt !important;'"><div v-html="fieldNameAddress(field)"></div></v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid pa-0 class="palletListContainer">
      <v-layout style="max-height: calc(100vh - 210px);">
        <v-flex xs12 style="overflow-y: auto;" pa-2>
          <Panel title="Label report" class="labellingPanel" v-if="isInLabelling" :key="updateCounter">
            <div v-for="(categoryTask, i) in categoryTasks" v-bind:key="i" :style="'width: 100%;'">
              <table class="category">
                <tr v-if="i > 0">
                  <td colspan="5" style="border-top: 1px solid #004d40; padding-bottom: 20px;"></td>
                </tr>
                <tr>
                  <td style="width: 40px;" v-if="categoryTask && categoryTask.category">
                    <div v-if="!(categoryTask.category.color.secondColor && categoryTask.category.color.secondColor !== '')" :style="'width: 25px; height: 25px; background-color: #' + categoryTask.category.color.color + '; border: 1px solid #cccccc; display: table-cell;'"></div>
                    <div v-if="categoryTask.category.color.secondColor && categoryTask.category.color.secondColor !== ''" :style="'width: 25px; height: 25px; background: repeating-linear-gradient(-45deg, #' + categoryTask.category.color.color + ', #' + categoryTask.category.color.color + ' 3px, #' + categoryTask.category.color.secondColor + ' 3px, #' + categoryTask.category.color.secondColor + ' 6px); border: 1px solid #cccccc; display: table-cell;'"></div>
                  </td>
                  <td v-if="categoryTask.category && categoryTask.category.image" style="width: 40px;">
                    <v-icon class="tag" @click="showCategoryImage(categoryTask.category.image)">fa-tag</v-icon>
                  </td>
                  <td v-if="categoryTask.category">
                    {{ categoryTask.category.label }}
                  </td>
                  <td v-if="!categoryTask.category">
                    <div class="categoryInput" style="display: inline-block;">
                      <v-text-field v-model="categoryTask.categoryName" solo/>
                    </div>
                    <v-icon v-if="canDeleteCategory(categoryTask)" @click="deleteCategory(categoryTask, i)">delete</v-icon>
                  </td>
                  <td v-if="!categoryTask.category">&nbsp;</td>
                  <td v-if="!categoryTask.category || (categoryTask.category && !categoryTask.category.image)">&nbsp;</td>
                  <td style="text-align: right; font-weight: bold;">
                    Total: {{ getTotal(categoryTask) }}
                  </td>
                </tr>
              </table>
              <table class="sequences">
                <tr>
                  <th style="width: 60px;">&nbsp;</th>
                  <th style="width: 120px; text-align: center;">Amount</th>
                  <th>&nbsp;</th>
                  <th style="width: 250px; text-align: center;">Sequence start</th>
                  <th></th>
                  <th style="width: 250px; text-align: center;">Sequence end</th>
                  <th></th>
                </tr>
                <tr v-for="(sequence, j) in filterSequences(categoryTask.sequences)" v-bind:key="j">
                  <td style="text-align: right; padding-right: 20px; height: 45px;">{{ (j+1) }}</td>
                  <td>
                    <div class="amountInput" @click="openAmountDialog(categoryTask, sequence, j, 'AMOUNT')" v-if="showAmount(sequence)">{{ sequence.amount }}</div>
                  </td>
                  <td style="width: 75px; font-size: 30px; text-align: center;">
                    <v-icon style="line-height: 35px;" @click="toggleMode(sequence)">swap_horiz</v-icon>
                  </td>
                  <td style="width: 250px;">
                    <div style="float: right;" class="sequenceInput" @click="openAmountDialog(categoryTask, sequence, j, 'START')" v-if="showSequence(sequence)">{{ sequence.sequenceStart }}</div>
                  </td>
                  <td style="width: 75px; font-size: 30px; text-align: center;"><div v-if="showSequence(sequence)">&rightarrow;</div></td>
                  <td style="width: 250px;">
                    <div class="sequenceInput" @click="openAmountDialog(categoryTask, sequence, j, 'END')" v-if="showSequence(sequence)">{{ sequence.sequenceEnd }}</div>
                  </td>
                  <td style="padding-left: 10px;">
                    <v-icon v-if="canDeleteSequence(categoryTask, j)" @click="deleteSequence(categoryTask, j)">delete</v-icon>
                  </td>
                  <td>
                    <div v-if="j === filterSequences(categoryTask.sequences).length - 1" style="float: right;">
                      <v-btn flat @click="saveTaskAndWarnIfNotSaved(categoryTask)" v-if="canSaveCategory(categoryTask)" class="saveCategory" style=" margin-right: 10px;">Save</v-btn>
                      <v-btn flat @click="addSequence(categoryTask)" class="addSequence">Add amount / sequence</v-btn>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <table class="category">
              <tr>
                <td colspan="5" style="border-top: 1px solid #004d40; padding-bottom: 24px;">
                </td>
              </tr>
              <tr>
              <tr>
                <td style="text-align: right;">
                  <div style="font-weight: bold; display: inline-block; padding-left: 48px; padding-right: 12px; margin-right: -12px; border-bottom: 2px solid #004d40;">
                    Total: {{ getTotalForAll() }}
                  </div>
                </td>
              </tr>
            </table>
            <v-dialog v-model="amountDialog" width="70vh" content-class="numberPadDialog" attach=".labellingPanel" persistent>
              <div class="numberPadDialogContainer">
                <table class="numberPad" style="width: 100%;">
                  <tr>
                    <td colspan="3"><div class="numberPadValue">{{ sequenceValue }}</div></td>
                    <td rowspan="5" class="wide"><div class="saveAmountBtn" @click="saveAndCloseAmountDialog"><v-icon>done</v-icon></div></td>
                  </tr>
                  <tr>
                    <td><div class="numberBtn" @click="numberClick(1)">1</div></td>
                    <td><div class="numberBtn" @click="numberClick(2)">2</div></td>
                    <td><div class="numberBtn" @click="numberClick(3)">3</div></td>
                  </tr>
                  <tr>
                    <td><div class="numberBtn" @click="numberClick(4)">4</div></td>
                    <td><div class="numberBtn" @click="numberClick(5)">5</div></td>
                    <td><div class="numberBtn" @click="numberClick(6)">6</div></td>
                  </tr>
                  <tr>
                    <td><div class="numberBtn" @click="numberClick(7)">7</div></td>
                    <td><div class="numberBtn" @click="numberClick(8)">8</div></td>
                    <td><div class="numberBtn" @click="numberClick(9)">9</div></td>
                  </tr>
                  <tr>
                    <td><div class="numberBtn" @click="clear()">Clr</div></td>
                    <td><div class="numberBtn" @click="numberClick(0)">0</div></td>
                    <td><div class="numberBtn" @click="backspace()"><v-icon style="color: #DDDDDD; font-size: 5vh;">keyboard_backspace</v-icon></div></td>
                  </tr>
                </table>
              </div>
            </v-dialog>
          </Panel>
        </v-flex>
      </v-layout>
    </v-container>
    <div style="background-color: rgba(0, 0, 0, 0.25); position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;" @click="showCategoryImageDialog = false" v-if="isInLabelling && showCategoryImageDialog">
      <img :src="categoryImageUrl" style="max-width: 80%; max-height: 80%; border: 5px solid white; border-radius: 5px;"/>
    </div>

    <v-dialog v-model="confirmEndDayDialog" attach=".labellingPanel" width="500" class="confirmEndDayDialog" v-if="isInLabelling" :key="'edd_' + updateCounter">
      <v-card pa-5>
        <v-card-title class="headline">End day</v-card-title>
        <v-card-text>You are about to end labelling on this field for {{ toDateDanish(currentDate) }}.<br/>Do you want to continue?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="endDay" class="bw-3">Yes</v-btn>
          <div style="width: 10px;"></div>
          <v-btn flat @click="confirmEndDayDialog = false" class="bw-3">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmCompleteDialog" attach=".labellingPanel" width="500" class="confirmCompleteDialog" v-if="isInLabelling" :key="'cd_' + updateCounter">
      <v-card pa-5>
        <v-card-title class="headline">Complete labelling</v-card-title>
        <v-card-text>You are about to complete labelling on this field.<br/>Do you want to continue?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="completeTasks" class="bw-3">Yes</v-btn>
          <div style="width: 10px;"></div>
          <v-btn flat @click="confirmCompleteDialog = false" class="bw-3">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="printDialog" attach=".supplierButtons" width="40vw" class="printDialog" v-if="!isInLabelling && showSupplierList" :key="updateCounter">
      <v-card pa-5>
        <v-card-title class="headline">Print label report</v-card-title>
        <v-card-text style="padding: 30px 40px 0 50px;">
          <v-radio-group v-model="printType">
            <table>
              <tr>
                <td>
                  <v-radio value="unapproved" color="#004d40"></v-radio>
                </td>
                <td>Completed label report</td>
              </tr>
              <tr>
                <td>
                  <v-radio value="approved" color="#004d40"></v-radio>
                </td>
                <td>Approved label report</td>
              </tr>
            </table>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="doPrint" class="bw-3">Print</v-btn>
          <div style="width: 10px;"></div>
          <v-btn flat @click="printDialog = false" class="bw-3">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ErrorDialog ref="errorDialog"/>
  </v-flex>
</template>

<script>
import Panel from '../components/Panel'
import ErrorDialog from '../components/ErrorDialog'
import DateUtil from '@/assets/javascript/dateutil'
import NumberUtil from '@/assets/javascript/numberutil'
import axios from 'axios'

export default {
  name: 'TodoLabelling',
  components: { Panel, ErrorDialog },
  data () {
    return {
      currentDate: null,
      currentDateMenu: null,
      currentSupplier: null,
      currentField: null,
      currentTask: null,
      currentSequence: null,
      currentIndex: 0,
      sequenceValueMode: null,
      tasks: [],
      categoryTasks: [],
      amountDialog: false,
      showCategoryImageDialog: false,
      categoryImageUrl: '',
      confirmEndDayDialog: false,
      confirmCompleteDialog: false,
      printDialog: false,
      printType: null,
      updateCounter: 0
    }
  },
  created: function () {
    this.startLabelling()
    document.addEventListener('keydown', this.keydownHandler)
  },
  destroyed: function () {
    document.removeEventListener('keydown', this.keydownHandler)
  },
  computed: {
    suppliers: function () {
      let suppliers = []
      for (let t of this.tasks) {
        if (suppliers.filter(s => s.id === t.supplier.id).length === 0) {
          suppliers.push(t.supplier)
        }
      }
      suppliers.sort(function (s1, s2) {
        let res = (s1.name).localeCompare((s2.name))
        if (res === 0) {
          res = (s1.number + '').localeCompare((s2.number + ''))
        }
        return res
      })
      return suppliers
    },
    fields: function () {
      let fields = []
      if (this.currentSupplier) {
        for (let t of this.tasks) {
          if (this.currentSupplier.id === t.supplier.id) {
            if (fields.filter(f => f.id === t.field.id).length === 0) {
              fields.push(t.field)
            }
          }
        }
        fields.sort(function (f1, f2) {
          let res = (f1.address.nameAndText).localeCompare((f2.address.nameAndText))
          if (res === 0) {
            res = (f1.id + '').localeCompare((f2.id + ''))
          }
          return res
        })
      }
      return fields
    },
    showSupplierList: function () {
      return !this.showFrontPage && !this.currentSupplier
    },
    showFieldList: function () {
      return !this.showSupplierList && !this.currentField
    },
    isInLabelling: function () {
      return this.currentField && this.categoryTasks && this.categoryTasks.length > 0
    },
    isConnected: function () {
      return this.$store.getters['session/isConnected'] && this.isOnline
    },
    sequencesComplete: function () {
      let complete = false
      if (this.isInLabelling) {
        for (let categoryTask of this.tasks) {
          if (categoryTask.field.id === this.currentField.id) {
            complete = true
            if (categoryTask && categoryTask.sequences && categoryTask.sequences.length > 0) {
              for (let seq of categoryTask.sequences) {
                let start = NumberUtil.isPositiveInteger(seq.sequenceStart) ? Number(seq.sequenceStart) : -1
                let end = NumberUtil.isPositiveInteger(seq.sequenceEnd) ? Number(seq.sequenceEnd) : -1
                if ((start > -1 && end === -1) || (start === -1 && end > -1) || !(end >= start)) {
                  return false
                }
              }
            }
          }
        }
      }
      return complete
    },
    sequencesCompleteCurrentDay: function () {
      let complete = false
      if (this.isInLabelling) {
        for (let categoryTask of this.categoryTasks) {
          if (categoryTask && categoryTask.sequences && categoryTask.sequences.length > 0) {
            complete = true
            for (let seq of categoryTask.sequences) {
              if (this.currentDate !== seq.reportDate) {
                continue
              }
              let start = NumberUtil.isPositiveInteger(seq.sequenceStart) ? Number(seq.sequenceStart) : -1
              let end = NumberUtil.isPositiveInteger(seq.sequenceEnd) ? Number(seq.sequenceEnd) : -1
              if ((start > -1 && end === -1) || (start === -1 && end > -1) || !(end >= start)) {
                return false
              }
            }
          }
        }
      }
      return complete
    },
    categoriesComplete: function () {
      if (this.isInLabelling) {
        for (let categoryTask of this.categoryTasks) {
          if (!categoryTask.category && categoryTask.categoryName === '') {
            return false
          }
        }
      }
      return true
    },
    canComplete: function () {
      return this.sequencesComplete && this.categoriesComplete
    },
    allEndedCurrentDay: function () {
      for (let categoryTask of this.categoryTasks) {
        for (let sequence of this.filterSequences(categoryTask.sequences)) {
          if (sequence.ended === false) {
            return false
          }
        }
      }
      return true
    },
    canEndDay: function () {
      return this.sequencesCompleteCurrentDay && this.categoriesComplete && !this.allEndedCurrentDay
    },
    total: function () {
      if (this.currentTask) {
        let total = 0
        for (let seq of this.currentTask.sequences) {
          let start = NumberUtil.isPositiveInteger(seq.sequenceStart) ? Number(seq.sequenceStart) : -1
          let end = NumberUtil.isPositiveInteger(seq.sequenceEnd) ? Number(seq.sequenceEnd) : -1
          if (start > 0 && end >= start) {
            total += end - start + 1
          }
        }
        return total
      }
      return 0
    },
    sequenceValue: function () {
      if (this.currentSequence && this.sequenceValueMode) {
        switch (this.sequenceValueMode) {
          case 'START':
            return this.currentSequence.sequenceStart
          case 'END':
            return this.currentSequence.sequenceEnd
          case 'AMOUNT':
            return this.currentSequence.amount
        }
      }
      return null
    },
    today: function () {
      return DateUtil.dateToString(new Date())
    },
    todayMinus30Days: function () {
      let date = new Date()
      date.setDate(date.getDate() - 30)
      return DateUtil.dateToString(date)
    }
  },
  methods: {
    loadTasks: async function (callback) {
      this.tasks = []
      await axios.get('/backend/rest/label_report/task/open')
        .then(response => {
          this.tasks = response.data
          if (callback) {
            callback()
          }
        })
    },
    gotoFrontPage: function () {
      this.currentSupplier = null
      this.currentField = null
      this.currentTask = null
      this.$parent.$parent.gotoHome()
    },
    startLabelling: function () {
      this.currentDate = DateUtil.dateToString(new Date())
      this.currentSupplier = null
      this.currentField = null
      this.currentTask = null
      this.confirmEndDayDialog = false
      this.confirmCompleteDialog = false
      this.categoryTasks = []
      this.loadTasks()
    },
    selectSupplier: function (supplier) {
      this.currentSupplier = supplier
      this.currentField = null
      this.currentTask = null
    },
    selectField: function (field) {
      this.currentField = field
      this.currentTask = null
      this.initializeTasks()
    },
    initializeTasks: function () {
      this.categoryTasks = []
      if (this.currentField) {
        for (let t of this.tasks) {
          if (this.currentField.id === t.field.id) {
            this.categoryTasks.push(JSON.parse(JSON.stringify(t)))
          }
        }
      }
      if (this.currentField && this.categoryTasks) {
        for (let categoryTask of this.categoryTasks) {
          if (!categoryTask.sequences || this.filterSequences(categoryTask.sequences).length === 0) {
            categoryTask.sequences = [
              {
                id: 0,
                mode: 'AMOUNT',
                amount: '',
                sequenceStart: '',
                sequenceEnd: '',
                reportDate: this.currentDate
              }
            ]
          } else if (categoryTask.sequences && categoryTask.sequences.length > 0) {
            for (let seq of categoryTask.sequences) {
              if (seq.sequenceStart === 0) {
                seq.sequenceStart = ''
              }
              if (seq.sequenceEnd === 0) {
                seq.sequenceEnd = ''
              }
              if (seq.amount === 0) {
                seq.amount = ''
              }
            }
          }
        }
      }
      this.updateCounter++
    },
    dateChanged: function () {
      this.selectField(this.currentField)
    },
    fieldNameAddress: function (field) {
      let nameAddress = ''
      if (field.address.name && field.address.name !== '') {
        nameAddress += '<div style="font-weight: bold; font-size: 130%;">' + field.address.name + '</div>'
        nameAddress += '<div style="font-weight: bold; font-size: 60% !important;">' + field.address.text + '</div>'
      } else {
        nameAddress += field.address.text
      }
      return nameAddress
    },
    showCategoryImage: function (imageUuid) {
      this.categoryImageUrl = '/backend/image/' + imageUuid
      this.showCategoryImageDialog = true
    },
    filterSequences: function (sequences) {
      let filteredSequences = []
      if (sequences && sequences.length) {
        for (let sequence of sequences) {
          if (!sequence.reportDate || sequence.reportDate === '' || sequence.reportDate === this.currentDate) {
            filteredSequences.push(sequence)
          }
        }
      }
      return filteredSequences
    },
    addSequence: function (categoryTask) {
      categoryTask.sequences.push({
        id: -categoryTask.sequences.length,
        mode: 'AMOUNT',
        amount: '',
        sequenceStart: '',
        sequenceEnd: '',
        reportDate: this.currentDate
      })
      this.updateCounter++
    },
    deleteCategory: function (categoryTask, index) {
      this.categoryTasks.splice(index, 1)
      if (categoryTask.id > 0) {
        axios.delete('/backend/rest/label_report/task/' + categoryTask.id)
          .then(response => {
            this.loadTasks()
          })
      }
    },
    deleteSequence: function (categoryTask, index) {
      for (let seqIndex in categoryTask.sequences) {
        let seq = categoryTask.sequences[seqIndex]
        if (seq.reportDate === this.currentDate) {
          if (index === 0) {
            categoryTask.sequences.splice(seqIndex, 1)
            break
          } else if (index > 0) {
            index--
          }
        }
      }
    },
    saveTask: async function (categoryTask, reloadPage = true, currentDayOnly = true) {
      let ok = false
      delete categoryTask.notSaved
      if (categoryTask) {
        // console.log('Save task: ' + JSON.stringify(categoryTask, null, 2))
        categoryTask.reportDate = this.currentDate
        if (currentDayOnly) {
          categoryTask.sequences = this.filterSequences(categoryTask.sequences)
        }
        try {
          ok = await axios.post('/backend/rest/label_report/task', categoryTask)
            .then(response => {
              categoryTask.id = response.data.id
              return true
            })
            .catch(error => {
              console.log('Failed to save label report: ' + error)
              categoryTask.notSaved = true
              this.updateCounter++
              return false
            })
          if (ok && reloadPage) {
            await this.loadTasks()
            this.selectField(this.currentField)
            this.updateCounter++
          }
        } catch (err) {
          console.log('Failed to save label report: ' + err)
        }
      }
      return ok
    },
    saveTaskAndWarnIfNotSaved: async function (categoryTask) {
      categoryTask.ended = false
      let ok = await this.saveTask(categoryTask)
      if (!ok) {
        this.$nextTick(() => {
          this.$refs.errorDialog.errorTitle = 'Error'
          this.$refs.errorDialog.errorMessage = 'Failed to save label report.<br/>Please check your connection and try again.'
          this.$refs.errorDialog.errorDialog = true
        })
      }
    },
    addCategory: function () {
      // console.log('Category tasks: ' + JSON.stringify(this.categoryTasks, null, 2))
      if (this.categoryTasks) {
        this.categoryTasks.push({
          id: 0,
          categoryName: '',
          field: this.currentField,
          sequences: [
            {
              id: 0,
              mode: 'AMOUNT',
              amount: '',
              sequenceStart: '',
              sequenceEnd: '',
              reportDate: this.currentDate
            }
          ]
        })
        this.updateCounter++
      }
    },
    confirmEndDay: function () {
      this.confirmEndDayDialog = true
    },
    confirmCompleteTasks: function () {
      this.confirmCompleteDialog = true
    },
    endDay: async function () {
      let allOk = true
      for (let categoryTask of this.categoryTasks) {
        categoryTask.ended = true
        let ok = await this.saveTask(categoryTask, false)
        if (!ok) {
          allOk = false
        }
      }
      this.confirmEndDayDialog = false
      if (allOk) {
        await this.loadTasks()
        this.selectField(this.currentField)
      } else {
        this.$nextTick(() => {
          this.$refs.errorDialog.errorTitle = 'Error'
          this.$refs.errorDialog.errorMessage = 'Failed to end labelling day.<br/>Please check your connection and try again.'
          this.$refs.errorDialog.errorDialog = true
        })
      }
    },
    completeTasks: async function () {
      let allOk = true
      for (let categoryTask of this.categoryTasks) {
        categoryTask.completed = true
        let ok = await this.saveTask(categoryTask, false, false)
        if (!ok) {
          allOk = false
        }
      }
      this.confirmCompleteDialog = false
      if (allOk) {
        this.gotoFrontPage()
      } else {
        this.$nextTick(() => {
          this.$refs.errorDialog.errorTitle = 'Error'
          this.$refs.errorDialog.errorMessage = 'Failed to complete label report.<br/>Please check your connection and try again.'
          this.$refs.errorDialog.errorDialog = true
        })
      }
    },
    openAmountDialog: function (categoryTask, currentSequence, currentIndex, sequenceValueMode) {
      this.currentTask = categoryTask
      this.currentSequence = currentSequence
      this.currentIndex = currentIndex
      this.sequenceValueMode = sequenceValueMode
      this.amountDialog = true
    },
    saveAndCloseAmountDialog: function () {
      this.currentTask.ended = false
      this.saveTask(this.currentTask)
      this.amountDialog = false
    },
    numberClick: function (number) {
      let value = this.sequenceValue
      if (value === null) {
        value = 0
      }
      value = value + '' + number
      this.setSequenceValue(Number(value))
    },
    clear: function () {
      this.setSequenceValue('')
    },
    backspace: function () {
      let val = '' + this.sequenceValue
      if (val.length > 1) {
        let value = val.substring(0, val.length - 1)
        this.setSequenceValue(Number(value))
      } else {
        this.clear()
      }
    },
    setSequenceValue: function (value) {
      if (this.currentSequence && this.sequenceValueMode) {
        if (this.sequenceValueMode === 'START') {
          this.currentSequence.sequenceStart = value
        } else if (this.sequenceValueMode === 'END') {
          this.currentSequence.sequenceEnd = value
        } else if (this.sequenceValueMode === 'AMOUNT') {
          this.currentSequence.amount = value
        }
      }
    },
    hasSequenceAmount: function (sequence) {
      return NumberUtil.isPositiveInteger(sequence.amount)
    },
    hasSequenceStart: function (sequence) {
      return NumberUtil.isPositiveInteger(sequence.sequenceStart)
    },
    hasSequenceEnd: function (sequence) {
      return NumberUtil.isPositiveInteger(sequence.sequenceEnd)
    },
    showAmount: function (sequence) {
      return !this.showSequence(sequence)
    },
    showSequence: function (sequence) {
      return sequence.mode === 'SEQUENCE'
    },
    toggleMode: function (sequence) {
      if (this.showAmount(sequence)) {
        sequence.mode = 'SEQUENCE'
      } else {
        sequence.mode = 'AMOUNT'
      }
      this.updateCounter++
    },
    canSaveCategory: function (categoryTask) {
      return categoryTask.notSaved === true
    },
    canDeleteCategory: function (categoryTask) {
      return this.isInLabelling && !categoryTask.category
    },
    canDeleteSequence: function (categoryTask, index) {
      if (this.isInLabelling && this.filterSequences(categoryTask.sequences).length > 1) {
        if (this.showAmount(this.filterSequences(categoryTask.sequences)[index])) {
          return this.filterSequences(categoryTask.sequences)[index].amount === ''
        } else if (this.showSequence(this.filterSequences(categoryTask.sequences)[index])) {
          return this.filterSequences(categoryTask.sequences)[index].sequenceStart === '' && this.filterSequences(categoryTask.sequences)[index].sequenceEnd === ''
        }
      }
      return false
    },
    getTotal: function (categoryTask) {
      if (categoryTask && categoryTask.sequences) {
        let total = 0
        for (let seq of this.filterSequences(categoryTask.sequences)) {
          let start = NumberUtil.isPositiveInteger(seq.sequenceStart) ? Number(seq.sequenceStart) : -1
          let end = NumberUtil.isPositiveInteger(seq.sequenceEnd) ? Number(seq.sequenceEnd) : -1
          let amount = NumberUtil.isPositiveInteger(seq.amount) ? Number(seq.amount) : -1
          if (this.hasSequenceStart(seq) && this.hasSequenceEnd(seq) && start > 0 && end >= start) {
            total += end - start + 1
          } else if (this.hasSequenceAmount(seq) && amount) {
            total += amount
          }
        }
        return total
      }
      return 0
    },
    getTotalForAll: function () {
      let totalForAll = 0
      if (this.categoryTasks) {
        for (let categoryTask of this.categoryTasks) {
          totalForAll += this.getTotal(categoryTask)
        }
      }
      return totalForAll
    },
    openPrintDialog () {
      this.printType = 'unapproved'
      this.printDialog = true
    },
    doPrint () {
      this.printDialog = false
      if (this.printType === 'approved') {
        this.printApproved()
      } else if (this.printType === 'unapproved') {
        this.print()
      }
    },
    printApproved () {
      let params = ''
      axios.post('/backend/print/labelReports.xhtml', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/pdf' }), 'Label reports.pdf')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Label reports.pdf')
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    print () {
      let params = ''
      axios.post('/backend/print/labelReportTasks.xhtml', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/pdf' }), 'Label reports.pdf')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Label reports.pdf')
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    toDateDanish (dateTime) {
      return DateUtil.datetimeToDateDanish(dateTime)
    },
    keydownHandler: function (event) {
      if (this.amountDialog) {
        if (event.key >= '0' && event.key <= '9') {
          this.numberClick(Number(event.key))
        } else if (event.key === 'Backspace') {
          this.backspace()
        } else if (event.key === 'Delete') {
          this.clear()
        } else if (event.key === 'Enter') {
          this.saveAndCloseAmountDialog()
        } else if (event.key === 'Escape') {
          this.cancel()
        }
      }
    }
  }
}
</script>

<style scoped>
  button {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .v-btn.addSequence {
    border-radius: 5px;
    height: 38px !important;
    width: 240px;
    font-size: 18px !important;
  }
  .v-btn.saveCategory {
    border-radius: 5px;
    height: 38px !important;
    width: 120px;
    font-size: 18px !important;
    margin-right: 10px !important;
  }
  .v-btn.changeDate {
    border-radius: 5px;
    height: 34px !important;
    width: 190px;
    font-size: 110% !important;
  }
  .v-btn.addCategory {
    border-radius: 5px;
    height: 34px !important;
    width: 170px;
    font-size: 110% !important;
  }
  .v-btn.endDay {
    border-radius: 5px;
    height: 34px !important;
    width: 140px;
    font-size: 110% !important;
  }
  .v-btn.completed {
    border-radius: 5px;
    height: 34px !important;
    width: 150px;
    font-size: 110% !important;
  }
  .v-btn.printApproved {
    border-radius: 5px;
    height: 34px !important;
    width: 190px;
    font-size: 110% !important;
    margin-right: 10px !important;
  }
  .v-btn.print {
    border-radius: 5px;
    height: 34px !important;
    width: 150px;
    font-size: 110% !important;
  }
  .v-dialog__content .v-btn {
    border-radius: 5px !important;
  }
  .tag {
    color: #004d40;
    cursor: pointer;
  }
  table.category {
    width: 100%;
    font-size: 18px;
    border-collapse: collapse;
    margin-top: 15px;
    margin-bottom: 10px;
  }
  table.category td {
    padding-right: 15px;
  }
  table.sequences {
    width: 100%;
    font-size: 20px;
    border-collapse: collapse;
  }
  table.sequences th {
    font-size: 18px;
  }
  .amountInput {
    border: 1px solid #004d40;
    border-radius: 5px;
    height: 40px;
    width: 120px;
    cursor: pointer;
    font-size: 20px;
    line-height: 40px;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .sequenceInput {
    border: 1px solid #004d40;
    border-radius: 5px;
    height: 40px;
    width: 250px;
    cursor: pointer;
    font-size: 20px;
    line-height: 40px;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .numberPadDialog {
    box-shadow: none;
  }
  .numberPad {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
  }
  .numberPad tr {
    border: none;
  }
  .numberPad tr td {
    border: none;
    padding: 0.3vh;
    text-align: right;
    width: 22%;
  }
  .numberPad tr td.wide {
    width: 34%;
  }
  .numberBtn {
    width: 100%;
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .numberBtn:hover {
    background-color: rgba(0, 62, 48, 0.87);
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .numberPadValue {
    border: 1px solid #004d40;
    border-radius: 10px;
    height: 10vh;
    width: 100%;
    cursor: pointer;
    font-size: 7vh;
    line-height: 10vh;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .saveAmountBtn {
    width: 100%;
    height: 52.5vh;
    text-align: center;
    vertical-align: center;
    padding-top: 20vh;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .saveAmountBtn .v-icon {
    font-size: 10vh;
    color: rgb(221, 221, 221);
  }
  .categoryInput {
    border: 1px solid #004d40;
    border-radius: 5px;
    height: 40px;
    width: 90%;
    cursor: pointer;
    font-size: 20px;
    line-height: 40px;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoLabelling.vue